module.exports = __webpack_public_path__ + "static/media/a21.3be4f357.jpg";